import React, { useCallback } from 'react';
import { JourneyItemStateInterface } from '@context/reducers';
import {
  MapContainerPropsInterface,
  MarkerInterface,
} from './MapContainerType';
import Map from './Map';
import * as Styled from './MapContainerStyles';

function MapContainer({
  journeys,
  onClickActionMarker,
}: MapContainerPropsInterface) {
  const getActions = useCallback(
    (journey: JourneyItemStateInterface) => {
      if (!onClickActionMarker) return {};
      const isPendingRoute = journey.status.slug === 'pending_route';

      return {
        text: isPendingRoute ? 'Iniciar rota' : 'Confirmar entrega',
        onClick: isPendingRoute
          ? () => onClickActionMarker('openDrawerAddRoute', journey.id)
          : () => onClickActionMarker('confirmJourney', journey.id),
      };
    },
    [onClickActionMarker],
  );

  function getPropsMap(): MarkerInterface[] {
    const markers: MarkerInterface[] = journeys.map((journey) => {
      const { trucker } = journey;

      return {
        name: trucker.name,
        avatar: trucker.avatar,
        coordinates: [
          trucker.lastLocation.coordinates.lat,
          trucker.lastLocation.coordinates.lon,
        ],
        lastLocation: trucker.lastLocation,
        action: getActions(journey),
        journeyId: journey.id,
        occurrence: journey.occurrence,
      };
    });

    return markers;
  }

  return (
    <Styled.ContainerMap>
      <Map markers={getPropsMap()} />
    </Styled.ContainerMap>
  );
}

export default MapContainer;
